<template>
  <!-- -->
  <el-dialog v-model="showList" dialog-width="3" title="用户信息就更记录">
    <dialog-table>
      <yq-table :data="dataList">
        <yq-table-column label="操作人员" prop="employeeName" width="80rem"/>
        <yq-table-column label="操作时间" prop="operateTime" width="180rem"/>
        <yq-table-column label="操作内容" prop="typeName" width="80rem">
          <template v-slot="{row}">
            <span v-if="row.changeType === 'CREATE'">
              添加用户
            </span>
            <span v-if="row.changeType === 'SAVE'">
              修改用户
            </span>
          </template>
        </yq-table-column>
        <yq-table-column label="变更信息">
          <template v-slot="{row}">
            {{ row.changeInfo }}
          </template>
        </yq-table-column>
      </yq-table>
    </dialog-table>
    <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
  </el-dialog>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import employeeApi from "@/api/normal/sys/employeeApi"
import commonApi from "@/api/commonApi";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    YqTableColumn,
    YqTable,
    DialogTable, FormPage
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      showList: false,
      emList: [],
    };
  },
  async created() {
    this.emList = await commonApi.queryEmployeeList({})
  },
  methods: {
    showChangeList(employeeId) {
      this.searchInfo.employeeId = employeeId;
      this.dataList = [];
      this.showList = true;
      this.resetSearch();
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    async queryList() {
      const {records, totalCount} = await employeeApi.queryEmpChange(this.searchInfo)
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
  }
};
</script>

<style lang="scss" scoped>

</style>